type PromiseDict<T> = { [K in keyof T]: Promise<T[K]> }

export const promiseAllDict = async <T>(promises: PromiseDict<T>): Promise<T> => {
  const keys = Object.keys(promises) as (keyof T)[]
  const values = Object.values(promises)

  const resolvedValues = (await Promise.all(values)) as T[keyof T][]

  const result: Partial<T> = {}
  for (let i = 0; i < keys.length; i++) {
    result[keys[i]] = resolvedValues[i]
  }

  return result as T
}
